import React, { useState, useEffect } from "react";
import './rightDetails.scss';  
import { MultiSelect } from "primereact/multiselect";
import CreatableSelect from 'react-select/creatable';
import { LuCalendarClock } from "react-icons/lu";
import { IoCloseOutline } from "react-icons/io5";
import { CandidateActivity } from "./CandidateActivity";
import { useParams } from 'react-router-dom';
import candidateApi from "../../services/candidateApi";
import masterApi from "../../services/masterApi";
import { useForm, Controller } from "react-hook-form";
import { getMailBody } from "../../utils/common";
import { toast } from 'react-toastify';
import { ThreeDotLoader } from "../../components/Loader/Loader"; // Add this import
import Select from "react-select"


export const AddActivity = ({ closePopup , jobId, reloadData,jobCode }) => {
  const { id } = useParams(); 
  const [isLoading, setIsLoading] = useState(false); // Loader state
  const [candidateDetails, setCandidateDetails] = useState([]);  
  const [lookupLst, setLookupLst] = useState([]);
  const [lookupOutcomeLst, setLookupOutcomeLst] = useState([]);
  const [activeUsersLst, setActiveUsersLst] = useState([]);
  const [selectedOutcome, setSelectedOutcome] = useState(null);
  const [candidateData, setCandidateData] = useState(null);
  const [interviewRound, setInterviewRound] = useState(null);
  const [boards, setBoards] = useState([]);
   const [searchedUsers, setSerarchedUsers] = useState([])
  const { control,register,handleSubmit, formState: { errors } } = useForm();
  useEffect(() => {
    fetchDetails();        
}, [id]); 

useEffect(() => {

  const loadActionTaken = async () => {
    try {
       setIsLoading(true);
      const type ='CandidateActionTaken';
      const response = await masterApi.getLookups(type); 
      const data = response?.data?.data[0]; 
      if (data) {
          const lookupList = Object.values(data);
          console.log("Extracted Lookup List: ", lookupList);
          setLookupLst(lookupList); // Update the state
      } else {
          console.error("No data found");
      } 
    } catch (error) {
      toast.error("Error fetching candidate action lookup data", {
        position: "top-right",
        autoClose: 2000,
      })
      console.error("Error fetching getLookups:", error);
    }finally {
      setIsLoading(false); // Hide the loader after data is fetched
    }
  };
  const loadActionOutcome= async () => {
    try {
       setIsLoading(true);
      const type ='CandidateActionOutcome';
      const response = await masterApi.getLookups(type); 
      const data = response?.data?.data[0]; 
      if (data) {
          const lookupOutcomeList = Object.values(data);
          console.log("Extracted Lookup List: ", lookupOutcomeList);
          setLookupOutcomeLst(lookupOutcomeList); // Update the state
      } else {
          console.error("No data found");
      } 
    } catch (error) {
      toast.error("Error fetching candidate action outcome lookup data", {
        position: "top-right",
        autoClose: 2000,
      })
      console.error("Error fetching getLookups:", error);
    }finally {
      setIsLoading(false); // Hide the loader after data is fetched
    }
  };
  const loadActionTakenBy = async () => {
    try {
       setIsLoading(true);
      const response = await masterApi.getActiveUsers();
      const userformattedData = response?.data?.users?.map((user) => ({
        name: user.firstName + ' ' + user.lastName,
        code: user.id
      }));
      setActiveUsersLst(userformattedData);      
    } catch (error) {
      toast.error("Error fetching active users", {
        position: "top-right",
        autoClose: 2000,
      })
      console.error("Error fetching currencies:", error);
    }finally {
      setIsLoading(false); // Hide the loader after data is fetched
    }
  };
  loadActionTaken();
  loadActionOutcome();
  loadActionTakenBy();
}, []);

 useEffect(() => {
    fetchCandidateDetails();
    fetchBoards();
  }, []);

//  useEffect(() => {
//     fetchBoards();
//   }, []);

  const fetchBoards = async () => {
    try{
      setIsLoading(true);
      const res = await masterApi.getActiveBoard();
      if(res?.data?.ok){
        setBoards(res.data.activeboards);
    }
    }catch (error) {
      toast.error("Error fetching boards", {
        position: "top-right",
        autoClose: 2000,
      })
      console.error("Error fetching boards:", error);
    }finally {
      setIsLoading(false); // Hide the loader after data is fetched
    }
  };

  const fetchDetails = async () => {
    try{
      setIsLoading(true);
      const response = await candidateApi.getJobsByCandidate(id);
      console.log(response?.data);
      setCandidateDetails(candidateDetails);                     
    }
    catch (error) {
      toast.error("Error fetching candidate job details:", {
        position: "top-right",
        autoClose: 2000,
      })
      console.error("Error fetching candidate details:", error);
    }finally {
      setIsLoading(false); // Hide the loader after data is fetched
    }
  };

  const fetchCandidateDetails = async () => {
    try{
      setIsLoading(true);
      const response = await candidateApi.getCandidateById(id);
      if(response?.data){
        setCandidateData(response.data);
      }
    }
    catch (error) {
      toast.error("Error fetching candidate details", {
        position: "top-right",
        autoClose: 2000,
      })
      console.error("Error fetching candidate details:", error);
      }finally 
      {
      setIsLoading(false); // Hide the loader after data is fetched
    }
  };

const onSubmit = async (data) => {
  try {
  const activityDate = `${data.date} ${data.time}:00`;
  const outco = (data.actionOutcome) ? data.actionOutcome : null;
  
  const requestData = {
    candidateId: id,
    jobId: jobId,
    actionTaken: data.actionTaken,
    isBoardActivity: false,
    activityDate: activityDate,
    actionTakenByList: data.actionTakenBy?.filter((user) => user.code).map((user) => user.code), 
    createdActionTakenByList: data.actionTakenBy?.filter((user) => !user.code).map((user) => user.value),
    outcome: outco,
    remarks: data.remarks,
}; 

  const response = await candidateApi.createCandidateActivity(requestData);
  if(response?.data?.ok){
    toast.success(response?.data?.message, {
      position: "top-right",
      autoClose: 2000,
    })

    if (reloadData) {
      reloadData();  
    } 
    if(selectedOutcome === "Rejected"){
  
      const mailData = {
        firstName: candidateData?.firstName,
        lastName: candidateData?.lastName, 
        mailAddress: candidateData?.email,
        isRejected: true,
        isUsercreation: false,
      }
      try{
        const response = await masterApi.sendNotificationMail(mailData);
        if(response?.data?.ok){
          toast.success(response?.data?.message, {
            position: "top-right",
            autoClose: 2000,
          })
      }
      }
      catch (error) {
        console.error("Error sending notification mail:", error);
        toast.error("Could not send notification mail", {
          position: "top-right",
          autoClose: 2000,
        })
      }
  
    }
    closePopup();
  }
  else{
    toast.error("Something went wrong", {
      position: "top-right",
      autoClose: 2000,
    })
  }
}catch (error) {
  console.error("Error submitting activity:", error);
  toast.error("Something went wrong", {
    position: "top-right",
    autoClose: 2000,
  })
}finally {
  setIsLoading(false); // Hide the loader after data is fetched
}
};
  return (
    <div className="popup-container small-popup">
      {isLoading && <ThreeDotLoader />} {/* Loader overlay */}
      <div
        className="shadeClose"
        onClick={() => {
          closePopup();
        }}
      ></div>
      <div className="popup-inner">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="inner-design">
          <div className="popup-header d-flex align-items-center gap2">
            <h2>Add Activity {jobCode ? <span> - <em className="fw-light">{jobCode}</em></span> : ''}</h2>
            <button
              type="button"
              className="ms-auto close-btn"
              onClick={() => {
                closePopup();
              }}
            >
              <IoCloseOutline />
            </button>
          </div>

          <div className="popup-content">
            <div className="row">
              <div className="col-12 col-md-6 mb-4">
                <label className="form-label" >
                  Action taken <span className="asterisk danger">*</span>
                </label>
              < Controller
              name="actionTaken"
              control={control}
              rules={{
                required: 'Action taken is required', // Validation rule
              }}
              render={({ field }) => (
                <select {...field}
                  className={`form-select ${errors.actionTaken ? "is-invalid" : ""}`}
                  onChange={(e) => {
                    field.onChange(e);
                    lookupLst.map(lookup => {
                      if(parseInt(e.target.value) === lookup.id){
                        setInterviewRound(lookup.key);
                      }
                    });
                  }
                }>
                  {/* <option value="">Select</option>
                  {boards?.map((board) => (
                // <option key={board.id} value={board.id}>
                <option key={board.id} value={{isBoard: true, val: board.id}}>
                  {board.boardName}
                </option>
              ))} */}
              {lookupLst?.map((lookups) => (
              <option key={lookups.id} value={lookups.id}>
                {lookups.value}
              </option>))}
                </select>
              )} />
              </div>
              <div className="col-12 col-md-6 mb-4">
                <label className="form-label" >
                  Action taken by <span className="asterisk danger">*</span>
                </label>
                <Controller
              name="actionTakenBy"
              control={control}
              defaultValue={[]} 
              rules={{
                required: 'Action Taken by is required', // Validation rule
              }}
              render={({ field }) => (
              // <Select
              //   {...field}
              //   // options={activeUsersLst}
              //   options={searchedUsers}
              //   optionLabel="label" 
              //   display="chip"
              //   placeholder="Select"
              //   maxSelectedLabels={3}
              //   className={`w-full md:w-20rem form-control ${errors.actionTakenBy ? "is-invalid" : ""
              //   }`}
              //   isSearchable
              //   onInputChange={input => {
              //     if(input.length >= 3){
              //       const users = activeUsersLst.filter(user => user.name.toLowerCase().startsWith(input.toLowerCase()))
              //       setSerarchedUsers(users.map(user => ({label: user.name, code: user.code})))
              //       var a = 0;
              //     }
              //   }}
              //   isMulti
              // />
              <CreatableSelect
                {...field}
                // options={activeUsersLst}
                options={searchedUsers}
                placeholder="Select"
                maxSelectedLabels={3}
                className={`w-full md:w-20rem form-control ${errors.actionTakenBy ? "is-invalid" : ""
                }`}
                isSearchable
                value={field?.value}
                onCreateOption={createOption => {
                  const currentValue = Array.isArray(field.value) ? field.value : [];
                  field.onChange([...currentValue, { label: createOption, value: createOption, code: null }]);
                  var a = 0;
                }}
                onInputChange={input => {
                  if(input.length >= 3){
                    const users = activeUsersLst.filter(user => user.name.toLowerCase().startsWith(input.toLowerCase())).map(
                      (user) => ({label: user.name, value: user.code, code: user.code})
                    )
                    setSerarchedUsers([...users, ...field?.value])
                    var a = 0;
                  }
                }}
                isMulti
              />
              // <CreatableSelect
              //                   {...field}
              //                   isClearable
              //                   options={skillsLst}
              //                   value={field?.value} // Ensure value is populated
              //                   onChange={(selected) => field.onChange(selected)} // Sync changes
              //                   // onCreateOption={(newOption) => {
              //                   //   handleCreate(newOption);
              //                   //   field.onChange([...field?.value, { label: newOption, value: newOption }]);
              //                   // }}
              //                   onCreateOption={(newOption) => {
              //                     const currentValue = Array.isArray(field.value) ? field.value : [];
              //                     field.onChange([...currentValue, { label: newOption, value: newOption }]);
              //                   }}
              //                   onInputChange={(inputValue, { action }) => {
              //                     if (action === 'input-change') {
              //                       // Handle input change here
              //                       console.log('Input changed:', inputValue);
              //                       // You can add your custom logic here
              //                     }
              //                   }}
              //                   placeholder="Search or add a new item..."
              //                   className={`w-full ${errors.skillIds ? "is-invalid" : ""}`}
              //                   isMulti
              //                 />
              )} />
              </div>
              <div className="col-12 col-md-6 mb-4">
                <label className="form-label" >
                  Activity Date <span className="asterisk danger">*</span>
                </label>
                <div className={`${errors.date || errors.time ? 
                "form-control required input-club position-relative d-flex gap-2 align-items-center"
                 : "form-control input-club position-relative d-flex gap-2 align-items-center"
                  }`} >
                  <input type="date" placeholder="dd/mm/yy" {...register("date", {
                    required: "Date is required", })} className id="date"
                    />
                  <input type="time" placeholder="--:--" {...register("time", {
                    required: "Time is required", })}  id="time"/>
                  {/* <span><LuCalendarClock/></span> */}
                </div>
               
              </div>
              <div className="col-12 col-md-6 mb-4">
                <label className="form-label" >
                  Outcome 
                  {/* <span className="asterisk danger">*</span> */}
                </label>
                < Controller
                name="actionOutcome"
                control={control}
                // rules={{
                //   required: 'Action taken is required', // Validation rule
                // }}
                render={({ field }) => (
                  <select {...field}
                    className={`form-select ${errors.actionOutcome ? "is-invalid" : ""}`}
                    onChange={(e) => {
                      field.onChange(e);
                      lookupOutcomeLst.map(lookup => {
                        if(parseInt(e.target.value) === lookup.id){
                          setSelectedOutcome(lookup.value);
                        }
                      });
                    }
                  }>
                    <option value="">Select</option>
                    {lookupOutcomeLst?.map((lookups) => (
                  <option key={lookups.id} value={lookups.id}>
                    {lookups.value}
                  </option>
                ))}
                  </select>
                )} />
              </div>
              <div className="col-12 col-md-12 mb-4">
                <label className="form-label" >
                  Remarks 
                </label>
                <textarea {...register("remarks", )}  className="form-control h-100" placeholder="Please enter the notes about action" ></textarea>
              </div>
            </div>
          </div>

          <div className="popup-footer position-absolute w-100 d-flex">
            <div className="ms-auto d-flex gap-2">
              <button type="button" className="btn btn-dark btn-lg" onClick={closePopup}>
                Cancel
              </button>

              <button
                type="submit"
                className="btn btn-success btn-lg"
              >
                Add
              </button>
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>
  );
};
